import { useMemo } from "react";
import { useSubscriptionPlan, type SubscriptionPlan } from "./useSubscriptionPlan";

export type BusinessIntelligenceAccess = "none" | "full";
export type StaffPerformanceAccess = "none" | "full";

export interface FeatureEntitlements {
  plan: SubscriptionPlan;
  businessIntelligence: BusinessIntelligenceAccess;
  staffPerformance: StaffPerformanceAccess;
  /** Server mirrors: has_pro_growth_plan_access */
  isProGrowth: boolean;
  /** Any paid plan (Solo or Growth) */
  isPaid: boolean;
}

/**
 * Client-side gates aligned with DB helpers:
 * has_business_intelligence_access ≈ has_paid_plan_access
 * has_staff_performance_full_access ≈ has_paid_plan_access
 */
export function useFeatureEntitlements(): FeatureEntitlements {
  const plan = useSubscriptionPlan();
  return useMemo(() => {
    const isPaid = plan === "pro_solo" || plan === "pro_growth";
    const isProGrowth = plan === "pro_growth";
    return {
      plan,
      businessIntelligence: isPaid ? "full" : "none",
      staffPerformance: isPaid ? "full" : "none",
      isProGrowth,
      isPaid,
    };
  }, [plan]);
}
